<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">防伪默认回复</div>
      <!-- <div class="top">
        <h1>默认正品回复</h1>
      </div> -->
      <div class="main mains">
        <Form
          :model="formItem"
          :label-width="80"
          style="width: 100%; max-width: 600px; min-width: 300px"
        >
          <FormItem label="首次查询">
            <Input
              v-model="formItem.Ares"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="首次查询回复..."
            ></Input>
          </FormItem>

          <FormItem label="重复查询">
            <Input
              v-model="formItem.Bres"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="重复查询回复..."
            ></Input>
          </FormItem>

          <FormItem label="多次查询">
            <Input
              v-model="formItem.Cres"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="多次查询回复..."
            ></Input>
          </FormItem>

          <FormItem label="设置方法">
            <p style="color: #999">
              首次查询时间：@resultTime@<br />
              查询次数：@resultNum@
            </p>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="updatas()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import { GetResultList, updataResultList } from "@/api/index";
export default {
  data() {
    return {
      formItem: {
        Ares: "",
        Bres: "",
        Cres: "",
      },
    };
  },
  components: {},
  beforeCreate() {},
  mounted() {
    // 获取默认回复导语
    GetResultList({
      code: 1,
    }).then((res) => {
      if (res.code == 402) {
        this.$Notice.error({ title: "没有权限！" });
      }
      this.formItem = {
        Ares: res.AselRes,
        Bres: res.BselRes,
        Cres: res.CselRes,
      };
    });
  },
  updated() {},
  watch: {},
  methods: {
    updatas() {
      if (this.formItem.Ares == null || this.formItem.Bres == null || this.formItem.Cres == null) {
          this.$Notice.error({ title: "不可留空！" });
      }
      updataResultList({
        clientcode: 1,
        ares: this.formItem.Ares,
        bres: this.formItem.Bres,
        cres: this.formItem.Cres,
      }).then((res) => {
        if (res.code == 402) {
          this.$Notice.error({ title: "没有权限！" });
        }
        if(res == 1){
          this.$Notice.success({ title: "修改成功" });
        }
        // console.log(res);
      });
    },
  },
};
</script>
<style scoped  >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
